<template>
  <button
    type="button"
    :disabled="!isActive"
    class="px-6 py-1 text-white capitalize transition-all duration-150 ease-linear border rounded-lg shadow bg-fs-500 border-fs-500"
    :class="
      isActive
        ? 'hover:bg-fs-600 hover:border-fs-600 hover:shadow-lg focus:outline-none'
        : 'opacity-50 cursor-not-allowed'
    "
    @click="$emit('click-primary')"
  >
    <slot>{{ "Button_Next" | i18n }}</slot>
  </button>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: true
    }
  }
};
</script>
